const liveMap = {
  layers: {
    title: 'Kartenebene',

    filters: {
      powerType: {
        title: 'Ladeleistung',
        placeholder: 'Ladeleistung',
        options: {
          fast: 'Schnell',
          slow: 'Langsam',
          turbo: 'Turbo',
        },
      },

      operator: {
        title: 'Ladestationsbetreiber',
      },

      connectorType: {
        title: 'Steckertyp',
        placeholder: 'Steckertyp',
        options: {
          EC_Type_1: 'IEC Type 1',
          IEC_Type_2_J1772: 'IEC Type 2 (J1772)',
          IEC_Type_2: 'IEC Type 2',
          IEC_Type_3: 'IEC Type 3',
          CHAOJI: 'CHAOJI',
          NEMA: 'NEMA',
          TESLA: 'TESLA',
          CHADEMO: 'CHADEMO',
          GBT: 'AGB',
        },
      },

      vehicles: {
        title: 'Fahrzeuge',
      },
    },

    content: {
      traffic: {
        title: 'Verkehr',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        mildlyhigher: 'Leicht höher',
        trafficJam: 'Stau',
      },

      evsChargingPoints: {
        title: 'Ladestationen für Elektrofahrzeuge',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        chargingPointOptions: {
          fast: 'Schnellladestation',
          slow: 'Langsamer Ladepunkt',
        },
      },

      heatMap: {
        title: 'Wärmekarte',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        scaleOfDemand: 'Umfang der Nachfrage',
      },

      dots: {
        title: 'Punkte',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte sehen',
        numberOfDemands: 'Anzahl der Nachfragen',
      },

      tripsLiveStream: {
        title: 'Live-Stream von Fahrten',
        description: 'Ebenenbeschreibung, die erklärt, was wir auf der Karte zeigen',
        tripProgress: 'Fahrtverlauf',
        pickUp: 'Abholen',
        dropOff: 'Absetzen',
      },
    },
  },
};

export default liveMap;
